import React from "react";
import AudioControls from "../componments/AudioControllComponment";
import FloatingCardComponent from "../componments/FloatingCardComponment.jsx";
import { WebSocketManager } from "../operators/WebsocketOperator.jsx";
import sideImage from "../img/side.png";
import bgImage from "../img/bg.png";

function ConnectedView() {

  const handleDisconnect = () => {
    WebSocketManager.disconnect();
    console.log("Disconnected!");
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen relative bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

      <div className="relative w-[90%] max-w-4xl z-10">
        <FloatingCardComponent
          onDisconnect={handleDisconnect}
        />

        <div className="bg-gray-900/80 backdrop-blur-md shadow-xl rounded-xl overflow-hidden flex flex-col md:flex-row items-stretch border border-white/10">
          <div className="md:w-[35%] w-full aspect-square">
            <img
              src={sideImage}
              alt="Side"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="md:w-[65%] w-full flex items-center p-6">
            <div className="flex items-center gap-8 w-full">
              <div className="flex-shrink-0">
                <AudioControls />
              </div>
              <div className="text-left text-white">
                <h3 className="text-xl font-semibold mb-2 tracking-wide">
                  MovieGate Audio
                </h3>
                <p className="text-sm text-gray-300 leading-relaxed">
                  Here you can listen to and manage the park music. Adjust volumes and view the current status of the client.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed bottom-4 text-center w-full z-20">
        <p className="text-gray-400 text-sm">
          Es gibt kein {" "}
          <a
            href="/impressum"
            className="text-gray-200 underline hover:text-white transition"
          >
            Impressum
          </a>
        </p>
      </div>
    </div>
  );
}

export default ConnectedView;
